export default {
  expenseOrderTypeSetting: lang.templateByUuid("UID:P_UDHWN_17DD50DE050001B5","费用类型设置") /* "费用类型设置" */
};
